/** @type {import('next-seo').DefaultSeoProps} */
export default {
  titleTemplate: '%s | MantaDEX',
  title: 'Pool',
  defaultTitle: 'Pool',
  twitter: {
    handle: '@MantaDEX',
    site: '@MantaDEX',
    cardType: 'summary_large_image',
  },
}
